import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateFormatTransform',
})
export class DateFormatTransformPipe implements PipeTransform {
  transform(date: string, format: string | any = '', currentFormat = ''): any {
    return moment(date, currentFormat).format(format);
  }
}
